module.exports = __webpack_public_path__ + "static/media/clothe-type.15d9de64.svg";